import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, mergeProps as _mergeProps, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "class-diagram" }
const _hoisted_2 = ["width", "height"]
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["points"]
const _hoisted_5 = ["points", "marker-start", "marker-end"]
const _hoisted_6 = { class: "class-diagram-controls" }
const _hoisted_7 = { class: "class-diagram-legend" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ontos_class_box = _resolveComponent("ontos-class-box")!
  const _component_ontos_domain_box = _resolveComponent("ontos-domain-box")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      ref: "viewport",
      class: _normalizeClass(["class-diagram-viewport", {'is-panning': _ctx.panning}]),
      style: _normalizeStyle({'--diagram-height': `${_ctx.shownHeight}px`}),
      onPointerdown: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onPointerDown && _ctx.onPointerDown(...args))),
      onPointermove: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onPointerMove && _ctx.onPointerMove(...args))),
      onPointerup: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onPointerUp && _ctx.onPointerUp(...args))),
      onPointercancel: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onPointerUp && _ctx.onPointerUp(...args)))
    }, [
      _createElementVNode("div", {
        class: "class-diagram-canvas",
        style: _normalizeStyle(_ctx.canvasStyle)
      }, [
        (_openBlock(), _createElementBlock("svg", {
          class: "class-diagram-links",
          width: _ctx.diagram.width,
          height: _ctx.diagram.height
        }, [
          _cache[4] || (_cache[4] = _createStaticVNode("<defs data-v-da158a84><marker id=\"class-diagram-arrow\" markerWidth=\"10\" markerHeight=\"8\" refX=\"9\" refY=\"4\" orient=\"auto\" data-v-da158a84><path d=\"M0,0 L10,4 L0,8\" fill=\"none\" stroke=\"#546e7a\" stroke-width=\"1.4\" data-v-da158a84></path></marker><marker id=\"class-diagram-arrow-start\" markerWidth=\"10\" markerHeight=\"8\" refX=\"1\" refY=\"4\" orient=\"auto\" data-v-da158a84><path d=\"M10,0 L0,4 L10,8\" fill=\"none\" stroke=\"#546e7a\" stroke-width=\"1.4\" data-v-da158a84></path></marker><marker id=\"class-diagram-diamond\" markerWidth=\"14\" markerHeight=\"10\" refX=\"14\" refY=\"5\" orient=\"auto\" data-v-da158a84><path d=\"M0,5 L7,0 L14,5 L7,10 Z\" fill=\"#546e7a\" stroke=\"#546e7a\" stroke-width=\"1\" data-v-da158a84></path></marker><marker id=\"class-diagram-diamond-start\" markerWidth=\"14\" markerHeight=\"10\" refX=\"0\" refY=\"5\" orient=\"auto\" data-v-da158a84><path d=\"M0,5 L7,0 L14,5 L7,10 Z\" fill=\"#546e7a\" stroke=\"#546e7a\" stroke-width=\"1\" data-v-da158a84></path></marker></defs>", 1)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.drawnEdges, (edge) => {
            return (_openBlock(), _createElementBlock("g", {
              key: `edge-${edge.id}`,
              class: "class-diagram-edge",
              onClick: ($event: any) => (_ctx.onEdgeClick(edge))
            }, [
              _createElementVNode("title", null, _toDisplayString(edge.title), 1),
              _createElementVNode("polyline", {
                class: "class-diagram-hit",
                points: _ctx.pointsOf(edge),
                fill: "none",
                stroke: "transparent",
                "stroke-width": "14"
              }, null, 8, _hoisted_4),
              _createElementVNode("polyline", {
                class: "class-diagram-line",
                points: _ctx.pointsOf(edge),
                fill: "none",
                stroke: "#546e7a",
                "stroke-width": "1.4",
                "marker-start": _ctx.markerAt(edge, 'source'),
                "marker-end": _ctx.markerAt(edge, 'target')
              }, null, 8, _hoisted_5),
              _createElementVNode("text", _mergeProps({ class: "class-diagram-label" }, { ref_for: true }, _ctx.labelAt(edge, 'source')), _toDisplayString(edge.sourceLabel), 17),
              _createElementVNode("text", _mergeProps({ class: "class-diagram-label" }, { ref_for: true }, _ctx.labelAt(edge, 'target')), _toDisplayString(edge.targetLabel), 17)
            ], 8, _hoisted_3))
          }), 128))
        ], 8, _hoisted_2)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.drawnBoxes, (box) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: box.alias
          }, [
            (box.content.kind === 'class')
              ? (_openBlock(), _createBlock(_component_ontos_class_box, {
                  key: 0,
                  class: "class-diagram-box",
                  style: _normalizeStyle(_ctx.boxStyle(box)),
                  model: box.content.model,
                  "can-write": _ctx.canWrite,
                  onOpen: ($event: any) => (_ctx.onOpen({...$event, idea: box.content.model.alias}))
                }, null, 8, ["style", "model", "can-write", "onOpen"]))
              : (_openBlock(), _createBlock(_component_ontos_domain_box, {
                  key: 1,
                  class: "class-diagram-box",
                  style: _normalizeStyle(_ctx.boxStyle(box)),
                  domain: box.content.domain,
                  onOpen: ($event: any) => (_ctx.onOpen({kind: 'domain', domain: box.content.domain.alias}))
                }, null, 8, ["style", "domain", "onOpen"]))
          ], 64))
        }), 128))
      ], 4)
    ], 38),
    _createElementVNode("div", _hoisted_6, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.controls, (control) => {
        return (_openBlock(), _createBlock(_component_v_btn, {
          key: control.label,
          variant: "text",
          size: "small",
          density: "comfortable",
          icon: control.icon,
          title: control.label,
          "aria-label": control.label,
          onClick: ($event: any) => (control.act())
        }, null, 8, ["icon", "title", "aria-label", "onClick"]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_7, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.legend, (entry) => {
        return (_openBlock(), _createElementBlock("span", {
          key: entry.label,
          class: "class-diagram-legend-item"
        }, [
          _createVNode(_component_v_icon, {
            size: "x-small",
            color: entry.color
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(entry.icon), 1)
            ]),
            _: 2
          }, 1032, ["color"]),
          _createTextVNode(_toDisplayString(entry.label), 1)
        ]))
      }), 128))
    ])
  ]))
}